import React from 'react'

const NotFound = () => (
  <div className="page-content">
    <div className="row">
      <div className="col-md-12">
        <h4 className="text-center">Ooopps.! The Page you were looking for, could not be found.</h4>
      </div>
    </div>
  </div>
)

export default NotFound
